var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ASSETS } from "@rentiohq/web-assets";
import { Button } from "../../Button";
import { Icon } from "../../Icon";
import { Modal } from "../Modal";
import * as S from "../Modal.styled";
export var SuccessModal = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (_jsx(Modal, __assign({ width: "medium", components: {
            Header: function (_a) {
                var onClose = _a.onClose;
                return (_jsxs(S.SuccessHeader, { children: [_jsx(S.SuccessClose, { children: _jsx(Button, { appearance: "plain", onClick: onClose, children: _jsx(Icon, { source: "close" }) }) }), _jsx(S.SuccessImage, { dangerouslySetInnerHTML: { __html: ASSETS.successStar } })] }));
            },
        } }, props, { children: children })));
};
